import { render, staticRenderFns } from "./LinkageField.vue?vue&type=template&id=4663feb8&scoped=true"
import script from "./LinkageField.vue?vue&type=script&lang=js"
export * from "./LinkageField.vue?vue&type=script&lang=js"
import style0 from "./LinkageField.vue?vue&type=style&index=0&id=4663feb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4663feb8",
  null
  
)

export default component.exports